import { usePageTitle } from '@/hooks/use-document-title'
import Footer from './footer'

interface PolicySection {
  title: string
  body: string
}

const sections: PolicySection[] = [
  {
    title: 'What Information We Collect',
    body: 'We collect the information you give us when you create an account — such as your name and email address — along with the work you do on the platform, like code submissions, problem progress, and coaching notes. We also collect standard technical data such as IP address and browser information.',
  },
  {
    title: 'How We Use Your Information',
    body: 'We use your information to run the platform, track your progress, personalize your coaching experience, and improve our content and features. We do not sell your personal information.',
  },
  {
    title: 'How We Share Your Information',
    body: 'We share data with the service providers that power the platform — such as authentication, payment, and hosting providers — only as needed to operate the service. We may also disclose information when required by law or as part of a business transfer.',
  },
  {
    title: 'Cookies and Similar Technologies',
    body: 'We use cookies and similar technologies to keep you signed in and understand how the platform is used. You can control cookies through your browser settings, though some features require them to work.',
  },
  {
    title: 'How We Protect Your Information',
    body: 'We take reasonable technical and organizational measures to protect your data against unauthorized access, alteration, or loss.',
  },
  {
    title: 'How Long We Keep Your Information',
    body: 'We retain your information for as long as your account is active or as needed to provide the service and meet legal obligations.',
  },
  {
    title: 'Your Rights',
    body: 'You can request access to, correction of, or deletion of your personal information. Contact us and we will respond within a reasonable timeframe.',
  },
  {
    title: 'Contact',
    body: 'Questions about this policy or your data? Reach out through the contact information on our About Us page.',
  },
]

export default function PrivacyPolicy() {
  usePageTitle('Privacy Policy')

  return (
    <div className="flex min-h-[calc(100vh-4rem)] flex-col">
      <div className="container mx-auto max-w-4xl px-4 py-12">
        <h1 className="mb-4 text-4xl font-bold tracking-tight">
          Privacy Policy
        </h1>
        <p className="text-muted-foreground mb-12 max-w-3xl text-lg leading-relaxed">
          This policy explains what information Beyond CTCI collects, how we use
          it, and the choices you have about it.
        </p>

        {sections.map(({ title, body }) => (
          <section key={title} className="mb-10">
            <h2 className="mb-3 text-2xl font-semibold">{title}</h2>
            <p className="text-muted-foreground leading-relaxed">{body}</p>
          </section>
        ))}
      </div>
      <Footer />
    </div>
  )
}
